import React, {useEffect} from 'react';
import * as yup from 'yup';
import {useNavigate, useParams} from 'react-router-dom';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup/dist/yup';
import {deviceApi} from '../../../../api';
import {IDevice} from '../interfaces/IDevice';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {Card, CardBody, Col, Form, Row} from 'reactstrap';
import DeviceForm from './DeviceForm';
import {useTranslation} from 'react-i18next';

export const deviceFormSchema = yup
  .object({
    name: yup.string().required('No name provided.').min(3, 'Name is too short - should be 3 chars minimum.'),
    description: yup.string().required('No description provided.').min(10, 'Description is too short - should be 10 chars minimum.'),
    status: yup.boolean().required(),
  })
  .required();
const DeviceUpdate = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {id} = useParams();
  const methods = useForm<IDevice>({
    resolver: yupResolver(deviceFormSchema),
  });

  const onFormSubmit = async (formData: IDevice) => {
    const {data} = await deviceApi.updateDevice(Number(id), formData);
    data && navigate(-1);
  };

  useEffect(() => {
    if (id) {
      const getDevice = async (deviceId: number) => {
        const {data} = await deviceApi.getDevice(+deviceId);
        methods?.reset(data);
      };
      getDevice(+id);
    }
  }, [id, methods]);
  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('administrator.devices.deviceUpdate')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate('/app/admin/devices');
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods?.handleSubmit(onFormSubmit)} className="py-3">
              <DeviceForm register={methods?.register} errors={methods?.formState?.errors} />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.update')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default DeviceUpdate;
